(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-feature"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(root) {
    if (root.dataset.bannerReady) return;
    root.dataset.bannerReady = 'true';

    var slides = root.querySelectorAll('[data-banner-slide]');
    var dots = root.querySelectorAll('[data-banner-dot]');
    var prev = root.querySelector('[data-banner-prev]');
    var next = root.querySelector('[data-banner-next]');
    if (!slides.length) return;

    var index = 0;
    var auto = root.dataset.autoAdvance === 'true';
    var interval = (parseInt(root.dataset.interval, 10) || 6) * 1000;
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(n) {
      index = ((n % slides.length) + slides.length) % slides.length;
      slides.forEach(function(s, i) { s.classList.toggle('is-active', i === index); });
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === index); });
      restart();
    }

    function restart() {
      if (timer) { clearInterval(timer); timer = null; }
      if (auto && slides.length > 1 && !reduced && !document.hidden) {
        timer = setInterval(function() { go(index + 1); }, interval);
      }
    }

    function pause() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function(d, i) { d.addEventListener('click', function(e) { e.stopPropagation(); go(i); }); });
    if (prev) prev.addEventListener('click', function(e) { e.stopPropagation(); go(index - 1); });
    if (next) next.addEventListener('click', function(e) { e.stopPropagation(); go(index + 1); });

    /* Whole-slide click: navigate to slide's URL when click wasn't already on a link/button */
    slides.forEach(function(slide) {
      var url = slide.dataset.slideUrl;
      if (!url) return;
      slide.addEventListener('click', function(e) {
        if (e.target.closest('a, button, input, select, textarea')) return;
        window.location.href = url;
      });
    });

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', restart);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', restart);
    document.addEventListener('visibilitychange', function() {
      document.hidden ? pause() : restart();
    });

    root.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
    });

    go(0);
  }

  function initAll() {
    document.querySelectorAll('[data-banner-slideshow]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
